import type { AptosWalletAccount } from '@dynamic-labs-sdk/aptos';
import type { FC } from 'react';

import { SignTransactionDialog } from './SignTransactionDialog';

type AptosWalletActionsProps = {
  walletAccount: AptosWalletAccount;
};

export const AptosWalletActions: FC<AptosWalletActionsProps> = ({
  walletAccount,
}) => {
  return <SignTransactionDialog walletAccount={walletAccount} />;
};
